import { DataField } from './types';

type SectionGroup<T extends DataField> = {
  fields: T[];
  title: string;
  order: number;
};

export function groupFieldsBySections<T extends DataField>(
  fields: T[]
): {
  unsectionedFields: T[];
  sectionedGroups: SectionGroup<T>[];
} {
  const unsectionedFields: T[] = [];
  const sectionMap = new Map<
    string,
    { fields: T[]; title: string; order: number; index: number }
  >();
  let sectionIndex = 0;

  for (const field of fields) {
    if (!field.sectionTitle) {
      unsectionedFields.push(field);
      continue;
    }

    const existing = sectionMap.get(field.sectionTitle);
    if (existing) {
      existing.fields.push(field);
      if (typeof field.sectionOrder === 'number') {
        existing.order = Math.min(existing.order, field.sectionOrder);
      }
      continue;
    }

    sectionMap.set(field.sectionTitle, {
      fields: [field],
      index: sectionIndex++,
      title: field.sectionTitle,
      order:
        typeof field.sectionOrder === 'number'
          ? field.sectionOrder
          : Number.MAX_SAFE_INTEGER,
    });
  }

  const sectionedGroups = Array.from(sectionMap.values())
    .sort((a, b) => {
      if (a.order !== b.order) return a.order - b.order;
      return a.index - b.index;
    })
    .map(({ order, title, fields: groupedFields }) => ({
      order,
      title,
      fields: groupedFields,
    }));

  return { sectionedGroups, unsectionedFields };
}
